import type { AllRouteEndpoints } from "../routeTypes";
import { engagementSegments } from "@dashboardApi/apis/engagementSegments";
export const engagementSegmentsUpdateTagsCacheKeys: AllRouteEndpoints[] = [engagementSegments];
